var host = 'https://ltgcam.ru/server/';
export default host;


// WEBPACK FOOTER //
// ./src/components/host.js